import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "d-flex direction-column a-i-end location-addresses" }
const _hoisted_2 = { class: "wrapper-scheldules-title" }
const _hoisted_3 = { class: "pb-1 d-flex a-i-center" }
const _hoisted_4 = { class: "uppercase text-raleway-13 no-select w-100" }
const _hoisted_5 = { class: "d-flex a-i-end j-content-s-be w-100" }
const _hoisted_6 = ["value"]
const _hoisted_7 = { class: "location-addresses-list" }
const _hoisted_8 = ["onChange"]
const _hoisted_9 = {
  id: "saved_address",
  class: "d-flex a-i-center"
}
const _hoisted_10 = ["id", "checked", "disabled"]
const _hoisted_11 = ["for"]
const _hoisted_12 = { class: "skeleton-loading-line loading-address" }
const _hoisted_13 = { class: "d-flex" }
const _hoisted_14 = { class: "d-flex a-i-end j-content-s-be w-100 ml-1 mr-1" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "btn-pluse" }, null, -1)
const _hoisted_16 = { class: "text-raleway-11" }
const _hoisted_17 = { class: "d-flex a-i-end j-content-center w-100 mr-1 ml-1" }
const _hoisted_18 = { class: "text-raleway-11" }

import { PersonalDataComponent } from "../../../store/modules/accountDetails/type";
import { ChedulesDetails } from "@/store/modules/accountDetails/type";
import { setValues } from "../../../store/modules/newOrders/type";
import { ResetFormType } from "@/store/modules/newOrders/type";
import { Locations } from "@/store/modules/Locations/type";
import { computed, ref, watch } from "vue";
import { useStore } from "vuex";


export default /*#__PURE__*/_defineComponent({
  __name: 'selectAddress',
  props: {
    resetForm: { type: Function },
    values: {},
    setValues: { type: Function }
  },
  setup(__props: any) {

const props = __props;

const store = useStore();

const saveSelected = ref(
  computed<number>(() => store.getters.getSaveSelectAddress)
);
const locations = ref(
  computed<Locations[]>(() => store.getters?.getStockLocations)
);
const selectedId = ref(
  computed<number>(() => store.getters?.getSelectedSchedulesInLocation)
);
const locationSelected = ref(
  computed<Locations[]>(() => store.getters.getStockLocationsInSelectedAddress)
);

const loadingCopy = ref(false);

const copyAddress = () => {
  // store.commit("copyAddressInPostalcodeStock");
  const accountDetailsData = ref(
    computed<PersonalDataComponent>(
      () => store.getters.getPersonalDataComponenValuesAccountDetails
    )
  );
  const locationSelected = ref(
    computed<PersonalDataComponent>(
      () => store.getters.getPersonalDataComponentValues
    )
  );
  props.setValues({
    ...props.values,
    city_stock: locationSelected.value.city || accountDetailsData.value.city,
    region_stock:
      locationSelected.value.region || accountDetailsData.value.region,
    country_stock:
      locationSelected.value.country || accountDetailsData.value.country,
    postal_code_stock:
      locationSelected.value.postal_code ||
      accountDetailsData.value.postal_code,
    buyer_address_stock:
      locationSelected.value.full_address ||
      accountDetailsData.value.full_address,
  });
  loadingCopy.value = true;
  const copyText = document.getElementById("myInput") as HTMLInputElement;
  copyText.select();
  copyText.setSelectionRange(0, 99999);

  const text =
    copyText.value.replaceAll("  ", " ").replaceAll("undefined", "") || "";

  navigator.clipboard.writeText(text).then(() => (loadingCopy.value = false));
};

const selectAddress = (id: number | null) => {
  store.commit("updateSelectedSchedulesInLocation", { id });
  store.commit("updateAccountSchedulesLocation", locationSelected.value[0]);
};

watch(
  () => selectedId.value,
  () => {
    props.resetForm();
  }
);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.$tc("saved_addresses")), 1),
        _createElementVNode("div", {
          class: "save-adresses-btn d-flex a-i-center no-select copy-data w-100",
          onClick: copyAddress
        }, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("p", {
              class: _normalizeClass(["text-raleway-11 no-select w-100 text-center", { copy_loading: loadingCopy.value }])
            }, _toDisplayString(!loadingCopy.value ? _ctx.$tc("Copy address") : _ctx.$tc("loading")), 3)
          ]),
          _createElementVNode("input", {
            type: "text",
            id: "myInput",
            class: "display-none",
            value: 
              (_ctx.values.country_stock
                ? ' ' + _ctx.values.country_stock + ' '
                : locationSelected.value[0]?.geo_place_country
                ? ' ' + locationSelected.value[0]?.geo_place_country + ' '
                : '') +
              '' +
              (_ctx.values.region_stock
                ? ' ' + _ctx.values.region_stock + ' '
                : locationSelected.value[0]?.geo_place_region
                ? ' ' + locationSelected.value[0]?.geo_place_region + ' '
                : '') +
              '' +
              (_ctx.values.city_stock + ' '
                ? _ctx.values.city_stock
                : ' ' + locationSelected.value[0]?.geo_place_name + ' '
                ? locationSelected.value[0]?.geo_place_name
                : '') +
              '' +
              (_ctx.values.buyer_address_stock
                ? ' ' + _ctx.values.buyer_address_stock + ' '
                : ' ' + locationSelected.value[0]?.street
                ? ' ' + locationSelected.value[0]?.street + ' '
                : '') +
              '' +
              (locationSelected.value[0]?.house
                ? ' ' + locationSelected.value[0]?.house + ' '
                : '') +
              '' +
              (_ctx.values.postal_code_stock
                ? ' ' + _ctx.values.postal_code_stock + ' '
                : locationSelected.value[0]?.postal_code
                ? ' ' + locationSelected.value[0]?.postal_code + ' '
                : '')
            
          }, null, 8, _hoisted_6)
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_7, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(locations.value, (stock) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "pb-1 d-flex a-i-center",
            key: stock?.id || 0,
            onChange: ($event: any) => (saveSelected.value === selectedId.value && selectAddress(stock?.id))
          }, [
            _withDirectives(_createElementVNode("div", _hoisted_9, [
              _createElementVNode("input", {
                type: "radio",
                name: "select-scheldules_address no-select",
                class: _normalizeClass({ pointer: saveSelected.value === selectedId.value }),
                id: 'radio' + stock?.id,
                checked: selectedId.value === stock?.id,
                disabled: saveSelected.value !== selectedId.value
              }, null, 10, _hoisted_10),
              _createElementVNode("label", {
                class: _normalizeClass(["text-motserrat-14 ml-1 no-select", { pointer: saveSelected.value === selectedId.value }]),
                for: 'radio' + stock?.id
              }, [
                _createElementVNode("p", null, _toDisplayString(stock?.geo_place_country +
                  " " +
                  stock?.geo_place_region +
                  " " +
                  stock?.geo_place_name), 1),
                _createElementVNode("p", null, _toDisplayString(stock?.full_address + " " + stock?.postal_code), 1)
              ], 10, _hoisted_11)
            ], 512), [
              [_vShow, saveSelected.value && selectedId.value && stock?.full_address]
            ])
          ], 40, _hoisted_8))
        }), 128))
      ], 512), [
        [_vShow, !_unref(store).getters.getLocationLoading]
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_12, null, 512), [
        [_vShow, _unref(store).getters.getLocationLoading]
      ]),
      _createElementVNode("div", _hoisted_13, [
        _withDirectives(_createElementVNode("div", {
          id: "add_address",
          class: "save-adresses-btn mt-2 d-flex a-i-center pointer no-select",
          onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (selectAddress(-1)), ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_14, [
            _hoisted_15,
            _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t("Add address")), 1)
          ])
        ], 512), [
          [_vShow, saveSelected.value === selectedId.value && locations.value.length > 0]
        ]),
        _withDirectives(_createElementVNode("div", {
          id: "cancel_address",
          class: "save-adresses-btn mt-2 d-flex a-i-center pointer no-select",
          onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (selectAddress(saveSelected.value)), ["stop"]))
        }, [
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.$t("Cancel")), 1)
          ])
        ], 512), [
          [_vShow, saveSelected.value !== selectedId.value]
        ])
      ])
    ])
  ]))
}
}

})